import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../actions/userActions';

const Navigation: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logoutHandler = () => {
    dispatch(logout());

    navigate('/');
  };

  return (
    <nav className='account-nav'>
      <Link to={'/account'}>
        <h2>EZZE Bank</h2>
      </Link>
      <div className='links'>
        <Link to={'/details'}>
          <p>Your Accounts</p>
        </Link>
        <p onClick={logoutHandler}>Logout</p>
      </div>
    </nav>
  );
};

export default Navigation;
